import React, { useEffect } from "react";
import "./RecordsRequest.css";
import "bootstrap/dist/css/bootstrap.min.css";
import OptionsCards from "../../components/OptionsCards/OptionsCards";

export default function RecordsRequest({
  selectedRecordsRequestOption,
  handleCheckboxdRecordsRequestChange,
  onUploadFile,
  uploadedFiles,
}) {
  const options = [
    {
      id: 3,
      title: "Request Records Retrieval",
      description:
        "INTERTEL will request records found during medical canvassing, which will include, but not be limited to the following:",
      features: [
        { title: "Medical & Billing Records", isDisabled: false },
        { title: "Employment Records", isDisabled: false },
        { title: "Phone Records", isDisabled: false },
        { title: "Pharmacy Records", isDisabled: false },
        { title: "Worker's Compensation  & More!", isDisabled: false },
      ],
      header:
        "Requires a Medical Authorization and a Letter of Representation (LOR) to be Uploaded Below:",
      locations: [],
    },
    {
      id: 4,
      title: "I Do NOT Want to Request Records Retrieval",
      description: "",
      features: [],
      header: "",
      locations: [],
    },
  ];

  useEffect(() => {
    selectedRecordsRequestOption?.id !== 3 &&
      onUploadFile({ ...uploadedFiles, recordsRequest: null });
  }, [selectedRecordsRequestOption]);

  return (
    <div>
      <h1 className="txt-orange" id ="RecordsRequest">Records Request</h1>
      <p className="p-style">
        INTERTEL can expedite your case by retrieving records from locations
        found in your canvassing report.
      </p>
      <p className="p-style">Choose from the following options: </p>
      <div className="container">
        <OptionsCards
          options={options}
          selectedOption={selectedRecordsRequestOption}
          onCheckboxChange={(option) =>
            handleCheckboxdRecordsRequestChange(option)
          }
          onUploadFile={(file) =>
            onUploadFile({ ...uploadedFiles, recordsRequest: file })
          }
          onRemoveFile={() =>
            onUploadFile({ ...uploadedFiles, recordsRequest: null })
          }
          uploadedFilesNames={
            uploadedFiles?.recordsRequest?.name
              ? [uploadedFiles?.recordsRequest?.name]
              : undefined
          }
        />
        <p className="p-divv">
          Our records retrieval, powered by Ontellus, the nation's largest
          records retrieval partners best-in-class technology with unparalleled
          data security for insurance and claims litigation.
        </p>
      </div>
    </div>
  );
}
